module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/eu.530a3df4.svg";